export default __webpack_public_path__ + "static/media/pngfind.com-pin-png-524884.026be18d.png";